/**
 * Order service API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateSlaThresholdRequest { 
    sellerId?: number;
    status?: CreateSlaThresholdRequest.StatusEnum;
    maxDuration: string;
}
export namespace CreateSlaThresholdRequest {
    export type StatusEnum = 'CREATED' | 'AWAITING_CONFIRMATION' | 'AWAITING_PAYMENT' | 'CONFIRMED_PAYMENT' | 'PARTIALLY_PAID' | 'SHIPPED' | 'DELIVERED' | 'ISSUED' | 'CANCELED' | 'CANCELED_BY_SELLER' | 'CANCELED_BY_OPERATOR' | 'AWAITING_ASSEMBLY' | 'ASSEMBLY' | 'ASSEMBLED' | 'WAITING_DELIVERY' | 'RETURNED' | 'TIMEOUT' | 'BUY_IN_CREDIT' | 'STORED';
    export const StatusEnum = {
        CREATED: 'CREATED' as StatusEnum,
        AWAITING_CONFIRMATION: 'AWAITING_CONFIRMATION' as StatusEnum,
        AWAITING_PAYMENT: 'AWAITING_PAYMENT' as StatusEnum,
        CONFIRMED_PAYMENT: 'CONFIRMED_PAYMENT' as StatusEnum,
        PARTIALLY_PAID: 'PARTIALLY_PAID' as StatusEnum,
        SHIPPED: 'SHIPPED' as StatusEnum,
        DELIVERED: 'DELIVERED' as StatusEnum,
        ISSUED: 'ISSUED' as StatusEnum,
        CANCELED: 'CANCELED' as StatusEnum,
        CANCELED_BY_SELLER: 'CANCELED_BY_SELLER' as StatusEnum,
        CANCELED_BY_OPERATOR: 'CANCELED_BY_OPERATOR' as StatusEnum,
        AWAITING_ASSEMBLY: 'AWAITING_ASSEMBLY' as StatusEnum,
        ASSEMBLY: 'ASSEMBLY' as StatusEnum,
        ASSEMBLED: 'ASSEMBLED' as StatusEnum,
        WAITING_DELIVERY: 'WAITING_DELIVERY' as StatusEnum,
        RETURNED: 'RETURNED' as StatusEnum,
        TIMEOUT: 'TIMEOUT' as StatusEnum,
        BUY_IN_CREDIT: 'BUY_IN_CREDIT' as StatusEnum,
        STORED: 'STORED' as StatusEnum
    };
}


